import psfaConfig from './psfa';
import type { Page, Question } from '../types';

function getQuestionsForPage(page: Page): Question[] {
  if (page.pageType === 'question' || page.pageType === 'list') {
    return page.questions ?? [];
  }
  return [];
}

describe('PSFA autofillMath config', () => {
  it('references source fields that exist on the same page', () => {
    const errors: string[] = [];

    for (const section of psfaConfig.sections) {
      for (const subsection of section.subsections) {
        for (const page of subsection.pages) {
          const questions = getQuestionsForPage(page);
          const questionNames = new Set(
            questions.map((question) => String(question.name)).filter(Boolean)
          );

          for (const question of questions) {
            const autofillMath = question.autofillMath;
            if (!autofillMath) continue;

            for (const [alias, sourceFieldName] of Object.entries(autofillMath.fields)) {
              if (!questionNames.has(sourceFieldName)) {
                errors.push(
                  `${subsection.slug}/${page.name}/${question.name}: ${alias} -> ${sourceFieldName}`
                );
              }
            }
          }
        }
      }
    }

    expect(errors).toEqual([]);
  });
});
